module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABT0lEQVRYhe1Y7Q7DIAiEZe//yuxHpWHUDyjUrpmXNGlR9E5RtAALC/8N1AYi6jsgNisQ0aG9q4C4dfV2OlFPYCmfJgIA4GWtOCIPsM1eb4augCmEskllzJI7hEaj7+04C+YQ+lWkCcgeWSvCAjTx2UJc22gNZecBgI28d61E80poBhBxJ8/Epc2CFknrThUSQERfxLXN0Q72vntIWQNMWIaTF0zamyPCAvRoR/LFmQSXto1mJTovViK7G+Y8cFemHcEkYPYZ34PHh9AScDdqsX3Y0K9aA5E79H6ArJRNv5ifEcICHh9CLgGISPxIm64zqs/frXZqftqXUc0DspKcWvk+mnZdLr9rfmxr+Ul74YdNAS1itduTbDzrx9aon/IOAL6jxGFkokRb6N3SNI+URZw5+hp6vXBfXO75sYWeUdf1e+Iq4XHwk3YZQgsL/44Pv1b+VJfsqlYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IEFAVS.png
// module id = 66
// module chunks = 0